var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"id":"students-list","title":_vm.translate('Student:::Students', {}, 2),"is-root":true,"status":_vm.page_status,"waiting":_vm.waiting},on:{"statused":_vm.statused}},[_c('base-students-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }